import React from "react";

const MileStones = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M5 2h25.987a.675.675 0 01.588.34.688.688 0 01.002.684l-4.851 8.555 4.851 8.555a.69.69 0 01-.251.933.675.675 0 01-.34.09H7.717V34H5V2z"
          fill={fill}
      />
    </svg>
);

export default MileStones;
